<template>
  <Card
    v-if="isActive"
    tag="form"
    theme="flat"
    class="shop-floorplan-dialog-mutate-basis"
    @submit.prevent="$emit('submit')"
  >
    <template #header>
      <ImageSelector v-model="value.image" :items="floorplans" style="width: 100%" />
    </template>
    <template #default>
      <template v-if="value.image">
        <InputComponent v-if="value.image" v-model="value.image.name" :label="$t('name')" />
        <ShopConditionsInput v-model="value.conditions" />
      </template>
      <template v-else>
        <div class="col center middle fade">
          <FontAwesomeIcon :icon="['fal', 'angle-up']" />
          <span>{{ $t('selectx', { x: $tc('floorplan').toLowerCase() }) }}</span>
        </div>
      </template>
    </template>
    <template #footer>
      <ButtonComponent
        theme="error"
        :icon="['fal', 'times']"
        :label="$t('delete')"
        @click="() => $emit('remove', value)"
      />
      <slot name="navigation" />
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import { ReduceArrayUniqueByKey } from '@/utils'

import Card from '@/components/Card'
import ImageSelector from '@/components/Shop/Floorplans/ImageSelector'
import ShopConditionsInput from '@/components/Shop/Conditions/ConditionsInput'
import { InputComponent } from 'vue-elder-input'

const meta = {
  order: 2,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    selected: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  computed: {
    ...mapState('Shop', {
      floorplans(state) {
        return [...this.$path('item.reference.media.floorplan', state), this.$path('value.image')]
          .filter(Boolean)
          .reduce(ReduceArrayUniqueByKey('url'), [])
      },
    }),
    value: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('update:selected', val)
      },
    },
  },
  components: {
    Card,
    InputComponent,
    ImageSelector,
    ShopConditionsInput,
  },
}
</script>

<style lang="scss">
.shop-floorplan-dialog-mutate-basis {
  max-width: 900px;
  margin: 0 auto;

  .card__content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
}
</style>
